// extracted by mini-css-extract-plugin
export var content = "cookie-policy-rules-module--content--x9LQj";